import React from 'react';
import cameraStyles from './CameraLoading.module.css';

const CameraLoading = () => {
  return (
    <div className={cameraStyles.container}>
      <div className={cameraStyles['camera-container']}>
        <svg className={cameraStyles['progress-ring']} width="160" height="160">
          <circle
            className={cameraStyles['progress-ring-bg']}
            cx="80"
            cy="80"
            r="70"
            fill="none"
            strokeWidth="8"
          />
          <circle
            className={cameraStyles['progress-ring-circle']}
            cx="80"
            cy="80"
            r="70"
            fill="none"
            strokeWidth="8"
          />
        </svg>
        <div className={cameraStyles['camera-icon']}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
            <circle cx="12" cy="13" r="4" />
          </svg>
        </div>
      </div>
      <h2 className={cameraStyles.title}>REQUESTING CAMERA ACCESS...</h2>
      <p className={cameraStyles.subtitle}>Please allow camera and microphone access to continue.</p>
    </div>
  );
};

export default CameraLoading;
